module.exports = __webpack_public_path__ + "static/media/PriPumpImg.7051c1da.png";